import { render, staticRenderFns } from "./StagingTextSectionCitationToolbar.vue?vue&type=template&id=77e180a0"
import script from "./StagingTextSectionCitationToolbar.vue?vue&type=script&lang=ts"
export * from "./StagingTextSectionCitationToolbar.vue?vue&type=script&lang=ts"
import style0 from "./StagingTextSectionCitationToolbar.vue?vue&type=style&index=0&id=77e180a0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports